import React from 'react';
import PropTypes from 'prop-types';
import T from '../Translation';

export default function CertificationsSecOps(props) {
  const { description, children } = props;

  return (
    <div>
      <T
        tag="h2"
        id="services.managed-detection-and-response.cert-title"
        className="sub-title text-certego-blue! font-bold mb-8"
      >
        Certifications
      </T>
      <div className="mx-auto">
        <div className="rounded-2xl text-certego-black bg-certego-lightgray p-8 pb-12">
          {description || (
            <T tag="p" id="services.managed-detection-and-response.cert-subtitle" className="mb-6">
              The incident analysis and investigation activities are carried out by the Security Operations team,
              composed of senior professionals with many years of experience in cybersecurity and holding key
              internationally recognized certifications for incident management:
            </T>
          )}
          <ul className="list-disc pl-8 grid gap-2">
            {[
              'ISC2 Certified Information Systems Security',
              'Professional (CISSP)',
              'GIAC Cloud Security Automation',
              'GIAC Exploit Researcher and Advanced',
              'GIAC Penetration Tester',
              'GSA Trusted Cloud Provider',
              'ISECOM OSSTMM Professional Security Tester (OPST)',
            ].map((c, i) => (
              <T tag="li" key={c} id={`services.managed-detection-and-response.cert-subtitle-${i + 1}`}>
                {c}
              </T>
            ))}
          </ul>
          {children}
        </div>
      </div>
    </div>
  );
}

CertificationsSecOps.propTypes = {
  description: PropTypes.any,
  children: PropTypes.any,
};
